import React, { useRef, useState, useCallback, useEffect } from "react"
import styled from "styled-components"
import { useMediaQuery } from "@mui/material"
import { useTheme } from "@mui/material/styles"

// @ts-ignore
import TawkMessengerReact from "@tawk.to/tawk-messenger-react"

const StyledMessenger = styled(TawkMessengerReact)``

export const useGetChat = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("md"))
  const tawkMessengerRef: any = useRef()
  const [fn, setFn] = useState(tawkMessengerRef.current)

  const onLoad = useCallback(() => {
    if (tawkMessengerRef.current && !fn) {
      setFn(tawkMessengerRef.current)
    }
  }, [fn])

  useEffect(() => {
    if (fn) {
      if (isMobile) {
        fn.hideWidget()
      } else {
        fn.showWidget()
      }
    }
  }, [fn, isMobile, onLoad])

  return {
    ChatComponent: () =>
      isMobile ? (
        <></>
      ) : (
        <StyledMessenger
          propertyId="5e79e55935bcbb0c9aa9c06b"
          widgetId="default"
          ref={tawkMessengerRef}
          onLoad={onLoad}
        />
      ),
    fn,
  }
}
